import { render } from "./HotkeyItem.vue?vue&type=template&id=abadaa8a"
import script from "./HotkeyItem.vue?vue&type=script&lang=js"
export * from "./HotkeyItem.vue?vue&type=script&lang=js"

import "./HotkeyItem.vue?vue&type=style&index=0&id=abadaa8a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__